
<ui-clinng-error-page [logo]="logo" [alt]="alt" ></ui-clinng-error-page>